export default function Placeholder(){

    return <>
        <h1 className="loading__message">Times Square | Loading...</h1>
    </>    

}